module.exports = {"230702002":"旭日社区","230702003":"林都社区","230702005":"北郡社区","230702008":"东升街道","230702009":"红升社区","230702010":"永红社区","230702011":"南郡社区","230702012":"新欣社区","230702013":"扶林社区","230702014":"前进社区","230702015":"红光社区","230702016":"朝阳社区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230702.json
// module id = 830
// module chunks = 0